module.exports = __webpack_public_path__ + "static/media/ehms-pic2.15bb6fd8.JPG";